// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 智能ai诊股详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock-ai-diagnose/detail */
export async function stockAiDiagnoseDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAiDiagnoseDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockDiagnoseDetailResp>('/stock-ai-diagnose/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 智能诊股列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock-ai-diagnose/list */
export async function stockAiDiagnoseListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAiDiagnoseListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockDiagnoseDetailResp>('/stock-ai-diagnose/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 开始智能ai诊股 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock-ai-diagnose/start */
export async function stockAiDiagnoseStartUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAiDiagnoseStartUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStartStockDiagnoseResp>('/stock-ai-diagnose/start', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 停止智能AI诊股 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /stock-ai-diagnose/stop */
export async function stockAiDiagnoseStopUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAiDiagnoseStopUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/stock-ai-diagnose/stop', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
